import { render, staticRenderFns } from "./change-route1.vue?vue&type=template&id=616e0342&scoped=true&"
import script from "./change-route1.vue?vue&type=script&lang=js&"
export * from "./change-route1.vue?vue&type=script&lang=js&"
import style0 from "./change-route1.vue?vue&type=style&index=0&id=616e0342&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616e0342",
  null
  
)

export default component.exports